module.exports = __webpack_public_path__ + "img/red_058.10ca2c0d.png";